import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import * as actions from '../authActions';
import LoginForm from './LoginForm';

const LoginFormContainer = ({authReducer, 
  login, 
  hideAuthenticationModal,
  postForgotPassword,
  resetForgotPassword}) => {
  const {requestingLogin, forgotPasswordSuccess, checkedEmail} = authReducer;

  useEffect(() => {
    resetForgotPassword();
  }, []);

  const handleSubmitForgotPassword = email => {
    postForgotPassword(email);
  };


  return (
    <LoginForm
      id="Auth-LoginFormContainer"
      login={login}
      isRequesting={requestingLogin}
      hideAuthenticationModal={hideAuthenticationModal}
      checkedEmail={checkedEmail}
      resetForgotPassword={resetForgotPassword}
      forgotPasswordSuccess={forgotPasswordSuccess}
      handleSubmitForgotPassword={handleSubmitForgotPassword}
    />
  );
};

const mapStateToProps = state => ({
  authReducer: state.authReducer,
});

export default connect(
  mapStateToProps,
  actions
)(LoginFormContainer);
